import React from 'react';
import { Label, Popup, SemanticCOLORS } from 'semantic-ui-react';
import { ResumenMatricula } from '../../comun/tipos';

type EstadoAprobaciones = 'aprobado' | 'rechazado' | 'sin-supervision';

const mapaDeColoresDeAprobaciones: Record<EstadoAprobaciones, SemanticCOLORS> = {
    'aprobado': 'green',
    'rechazado': 'red',
    'sin-supervision': 'yellow',
};

const mapaDeNombresDeAprobaciones: Record<EstadoAprobaciones, string> = {
    'aprobado': 'Aprobado',
    'rechazado': 'Rechazado',
    'sin-supervision': 'Pendiente',
};

export interface Props extends Pick<ResumenMatricula, 'estadoAprobacion'> {
    nulo: boolean;
}

const EtiquetaDeEstadoAprobacion: React.FunctionComponent<Props> = ({ nulo, estadoAprobacion }) =>
    nulo ? (
        <Label circular horizontal style={{ width: '80px' }} content='Nulo' color='red' />
    ) : (
        <Popup
            open={estadoAprobacion.estado !== 'rechazado' ? false : undefined}
            trigger={
                <Label
                    circular
                    horizontal
                    style={{ width: '80px' }}
                    content={mapaDeNombresDeAprobaciones[estadoAprobacion.estado]}
                    color={mapaDeColoresDeAprobaciones[estadoAprobacion.estado]}
                />
            }
        >
            <Popup.Header content='Motivo:' />
            {estadoAprobacion.estado === 'rechazado' && (
                <Popup.Content>
                    <p style={{ whiteSpace: 'pre-line' }}>{estadoAprobacion.motivo}</p>
                </Popup.Content>
            )}
        </Popup>
    );

export default EtiquetaDeEstadoAprobacion;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/ListaDeProcesos/TablaDeProcesos/EtiquetaDeEstadoAprobacion.tsx